import { useState, useEffect } from 'react';

/**
 * Accepts @media rule and returns boolean depends of the actual window size,
 * on load and if user resizes their screen.
 * @param {string} query e.g. - '(min-width: 768px) and (max-width: 1279px)'
 * @returns {boolean}
 */

const useMediaQuery = (query: string) => {
  const [match, setMatch] = useState(false);

  useEffect(() => {
    const updateMatch = () => setMatch(window.matchMedia(query).matches);

    updateMatch();
    window.matchMedia(query).addEventListener('change', updateMatch);

    return () => {
      window.matchMedia(query).removeEventListener('change', updateMatch);
    };
  }, [query]);

  return match;
};

export default useMediaQuery;
